import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";

export const SURVEY_TAB_DASHBOARD = "dashboard";
export const SURVEY_TAB_MANAGEMENT = "management";
export const SURVEY_TAB_INVITATION = "invitation";
export const SURVEY_TAB_QUESTIONS_INFO = "questions_info";

/**
 * Cross-route tabs between Survey Dashboard, Survey Management, Survey Invitation, and Survey Questions Info.
 */
export default function SurveySectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showDashboard = hasPermission && hasPermission("menu.survey_dashboard");
  const showManagement = hasPermission && hasPermission("menu.surveys");
  const showInvitation = hasPermission && hasPermission("menu.survey_dashboard");
  const showQuestionsInfo = hasPermission && hasPermission("menu.surveys");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Survey sections">
      {showDashboard ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SURVEY_TAB_DASHBOARD}
          className={`tab-btn ${activeTab === SURVEY_TAB_DASHBOARD ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SURVEY_TAB_DASHBOARD) navigate("/SurveyDashboard");
          }}
        >
          Survey Dashboard
        </button>
      ) : null}
      {showManagement ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SURVEY_TAB_MANAGEMENT}
          className={`tab-btn ${activeTab === SURVEY_TAB_MANAGEMENT ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SURVEY_TAB_MANAGEMENT) navigate("/Surveys");
          }}
        >
          Survey Management
        </button>
      ) : null}
      {showInvitation ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SURVEY_TAB_INVITATION}
          className={`tab-btn ${activeTab === SURVEY_TAB_INVITATION ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SURVEY_TAB_INVITATION) navigate("/SurveyInvitation");
          }}
        >
          Survey Invitation
        </button>
      ) : null}
      {showQuestionsInfo ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === SURVEY_TAB_QUESTIONS_INFO}
          className={`tab-btn ${activeTab === SURVEY_TAB_QUESTIONS_INFO ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== SURVEY_TAB_QUESTIONS_INFO) navigate("/SurveyQuestionsInfo");
          }}
        >
          Survey Questions Info
        </button>
      ) : null}
    </TabsList>
  );
}
